import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useUrlQuery = ({ name, defaultValue = null }: { name: string, defaultValue?: string | string[] | null }): {
  queryValue: string[]
  setQueryValue: (value: string | string[]) => void
} => {
  const [searchParams, setSearchParams] = useSearchParams()

  const setQueryValue = useCallback((value: string | string[]) => {
    setSearchParams(
      pre => {
        pre.delete(name)
        const val = Array.isArray(value) ? value : [value]
        val.forEach(i => { pre.append(name, i) })
        return pre
      },
      { replace: true }
    )
  }, [name, setSearchParams])

  const queryValue = useMemo(
    () => searchParams.getAll(name) ?? defaultValue,
    [defaultValue, name, searchParams]
  )

  return {
    queryValue,
    setQueryValue
  }
}
